import React from 'react';
import styles from './footer.module.css';

const Footer = ({ dark = false, showSocial = false }) => (
    <footer className={`${styles.footer} ${dark ? styles.dark : ''}`}>
        <div className={styles.inner}>
            <div className={styles.company}>
                <strong className={styles.logo}>JSOFTWARE</strong>
                <p>제이소프트웨어 주식회사</p>
                <p>대표 이재희</p>
                <p>사업자등록번호 660-81-00795</p>
            </div>
            <div className={styles.details}>
                <section>
                    <h2>본점 주소</h2>
                    <address>서울특별시 강남구 테헤란로6길 30, 4층 432호</address>
                    <p className={styles.note}>사업자등록 주소이며, 방문 미팅은 별도 협의합니다.</p>
                </section>
                <section>
                    <h2>미팅 안내</h2>
                    <p>대면 미팅은 사전 협의 후 신논현역 인근에서 진행합니다.</p>
                    <p className={styles.note}>구체적인 장소는 일정 확정 시 안내드립니다.</p>
                </section>
                <section>
                    <h2>협업 문의</h2>
                    <p>현재 정기 채용은 진행하지 않습니다. 프로젝트의 수행 조건과 업무 범위에 따라 개발·디자인 등 분야별 협업을 검토합니다.</p>
                    <p className={styles.note}>전문 분야, 주요 수행 경험, 참여 가능한 기간을 이메일로 보내주세요.</p>
                    <a className={styles.collaborationLink} href={`mailto:lee.jaehee@jsoftware.co.kr?subject=${encodeURIComponent('[협업 문의]')}`}>이메일로 협업 문의하기</a>
                </section>
                <section>
                    <h2>문의</h2>
                    <div className={styles.contacts}>
                        <a href="tel:01098761551">010-9876-1551</a>
                        <a href="mailto:lee.jaehee@jsoftware.co.kr">lee.jaehee@jsoftware.co.kr</a>
                    </div>
                </section>
            </div>
            <div className={styles.bottom}>
                <small>© {new Date().getFullYear()} Jsoftware Corp. All rights reserved.</small>
                {showSocial && <div className={styles.social}>
                    <a href="https://github.com/leejaehee1?tab=repositories" target="_blank" rel="noreferrer">GitHub</a>
                    <a href="https://gitlab.com/jsoftware1" target="_blank" rel="noreferrer">GitLab</a>
                </div>}
            </div>
        </div>
    </footer>
);
export default React.memo(Footer);
